import React from 'react';
import { AnimatedSection } from '../../components/ui/AnimatedSection';
import { Button } from '../../components/ui/Button';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function StrengthLongevity() {
  return <main className="w-full pt-32 pb-24 bg-dark min-h-screen" data-id="element-798">
      <article className="max-w-3xl mx-auto px-6" data-id="element-799">
        <AnimatedSection data-id="element-800">
          <Link to="/blog" className="inline-flex items-center text-gold hover:text-white transition-colors mb-8 text-sm font-bold uppercase tracking-wider" data-id="element-801">
            <ArrowLeftIcon className="w-4 h-4 mr-2" data-id="element-802" />
            Back to Insights
          </Link>

          <div className="mb-12" data-id="element-803">
            <span className="text-gold text-xs font-bold uppercase tracking-wider px-3 py-1 border border-gold/30 rounded-full mb-6 inline-block" data-id="element-804">
              Strength
            </span>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 font-heading leading-tight" data-id="element-805">
              Why Strength Training Is the Foundation of Longevity
            </h1>
            <p className="text-xl text-muted leading-relaxed mb-6" data-id="element-806">
              Muscle is not aesthetic — it is one of the strongest protectors of
              your health.
            </p>
            <div className="flex items-center text-sm text-muted font-medium border-t border-border pt-6" data-id="element-807">
              <span data-id="element-808">Oct 05, 2025</span>
              <span className="mx-3" data-id="element-809">•</span>
              <span data-id="element-810">5 min read</span>
            </div>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.2} className="prose prose-invert prose-lg max-w-none prose-headings:font-heading prose-headings:text-white prose-a:text-gold hover:prose-a:text-white prose-strong:text-white" data-id="element-811">
          <p data-id="element-812">
            Most people train to look better. Very few understand that strength
            is what keeps you alive longer.
          </p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-813">
            The Truth About Muscle
          </h3>
          <p data-id="element-814">
            Muscle is metabolic protection. It controls blood sugar, hormones,
            energy production, and aging speed.
          </p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-815">
            What Happens Without It
          </h3>
          <p data-id="element-816">
            Without enough muscle, your metabolism slows, fat storage increases,
            energy drops, and independence declines over time.
          </p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-817">
            Why Cardio Alone Is Not Enough
          </h3>
          <p data-id="element-818">
            Cardio burns calories. Muscle changes your biology. Without
            strength, you are not improving your system.
          </p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-819">
            What This Means for You
          </h3>
          <p data-id="element-820">
            If you feel weak, tired, or stuck despite effort, your body is not
            being challenged in the right way.
          </p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-821">
            The BioShift Perspective
          </h3>
          <p data-id="element-822">
            We build strength as a long-term protective system, not just a
            workout routine.
          </p>
          <p className="text-xl font-medium text-gold italic mt-8" data-id="element-823">
            Strength is not optional. It's protection.
          </p>
        </AnimatedSection>

        <AnimatedSection delay={0.3} data-id="element-824">
          <div className="mt-16 pt-12 border-t border-border text-center bg-surface p-10 rounded-lg" data-id="element-825">
            <h3 className="text-2xl font-bold text-white mb-4 font-heading" data-id="element-826">
              Ready to build metabolic armor?
            </h3>
            <p className="text-muted mb-8 max-w-lg mx-auto" data-id="element-827">
              Discover how our structured strength protocols can transform your
              body and extend your healthspan.
            </p>
            <Button href="https://holistic-health.bioshift.net/calender-booking" size="lg" data-id="element-828">
              Apply for Coaching
            </Button>
          </div>
        </AnimatedSection>
      </article>
    </main>;
}